export default __webpack_public_path__ + "locales/vi/DeleteProfileEverDialog.json?hash=1482278f572ff5082b12a5affc3a1937";